import { Eye, X } from 'lucide-react';
import type { Role } from '../lib/api';
import type { ViewAsState } from '../lib/viewAs';

// ─────────────────────────────────────────────────────────────────────────────
// ViewAsBanner
// Fixed, loud top banner rendered while a founder is impersonating a role.
// Visually unmistakable per docs/product/VIEW-AS-TOGGLE.md rule #4.
// ─────────────────────────────────────────────────────────────────────────────

export function ViewAsBanner({
  viewAs,
  realRole,
  onExit,
}: {
  viewAs: ViewAsState;
  realRole: Role;
  onExit: () => void;
}) {
  return (
    <div className="fixed inset-x-0 top-0 z-[60] border-b-2 border-red-500/80 bg-gradient-to-b from-red-950/95 to-red-900/80 backdrop-blur-xl">
      {/* animated red pulse strip along bottom edge */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px animate-pulse bg-red-400/60" />

      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-2.5 sm:px-6">
        <div className="flex items-center gap-3 min-w-0">
          <Eye className="h-4 w-4 shrink-0 text-red-300" strokeWidth={2.5} />
          <span className="font-display text-[10px] font-black uppercase tracking-[0.22em] text-red-300 shrink-0">
            Viewing as
          </span>
          <span className="font-display text-sm font-black uppercase tracking-wider text-white truncate">
            {viewAs.org ? `Org Admin · ${viewAs.org.orgName}` : viewAs.role}
          </span>
          <span className="hidden font-mono text-[10px] uppercase tracking-wider text-red-300/70 md:inline shrink-0">
            · real role: {realRole}
          </span>
        </div>

        <button
          onClick={onExit}
          className="flex shrink-0 items-center gap-1.5 border border-red-400/50 bg-red-950/60 px-3 py-1.5 font-display text-[10px] font-black uppercase tracking-wider text-red-100 transition-all hover:border-red-300 hover:bg-red-900/70 hover:text-white"
        >
          <X className="h-3 w-3" strokeWidth={3} />
          Exit
        </button>
      </div>
    </div>
  );
}
